module.exports = __webpack_public_path__ + "static/media/larsseit-thin.782e0013.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/larsseit/larsseit-thin.otf
// module id = 409
// module chunks = 0